import { JSX, useCallback } from "react";

import { AddEvent, Event } from "utils/history/Event";

import {
	Report,
	Role
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { Field } from "core/field/FieldService";

import AdminRoleTable from "core/trajectory/access/AdminRoleTable";
import EvaluationRoleTable from "core/trajectory/access/EvaluationRoleTable";
import InformationRoleTable from "core/trajectory/access/InformationRoleTable";
import ReportRoleTable from "core/trajectory/access/ReportRoleTable";
import { Tabs } from "core/trajectory/access/RolesOverview";

export interface RoleTableProps {
	selected: Tabs;
	roles: Role[];
	information: Field[];
	reports: Report[];
	editable: boolean;

	onChange: (event: Event) => void;
	onDelete: (index: number) => void;
}

export interface RoleRowProps {
	index: number;
	role: Role;
	editable: boolean;

	onChange: (event: Event) => void;
	onDelete: (index: number) => void;
}

function RoleTable(props: RoleTableProps): JSX.Element {
	const isValid = useCallback(
		(name: string): boolean =>
			name.trim() !== "" && !props.roles.some(role => role.name === name),
		[props.roles]
	);

	const onInsert = useCallback(
		(role: Role): void =>
			props.onChange(new AddEvent(`/roles/${props.roles.length}`, role)),
		[props.roles, props.onChange]
	);

	switch (props.selected) {
		case Tabs.INFORMATION:
			return (
				<InformationRoleTable
					{...props}
					isValid={isValid}
					onInsert={onInsert}
				/>
			);
		case Tabs.EVALUATION:
			return (
				<EvaluationRoleTable
					{...props}
					isValid={isValid}
					onInsert={onInsert}
				/>
			);
		case Tabs.REPORTS:
			return (
				<ReportRoleTable
					{...props}
					isValid={isValid}
					onInsert={onInsert}
				/>
			);
		case Tabs.ADMIN:
			return (
				<AdminRoleTable
					{...props}
					isValid={isValid}
					onInsert={onInsert}
				/>
			);
		default:
			return <></>;
	}
}

export default RoleTable;
